module.exports = __webpack_public_path__ + "static/media/cwb-thumb-img.137904d1.svg";